/* JLB Printing Theme JS */

// ─── MOBILE NAV ───
function initMobileNav() {
  const toggle = document.getElementById('mobile-nav-toggle');
  const nav = document.getElementById('mobile-nav');
  if (!toggle || !nav) return;
  toggle.addEventListener('click', () => {
    const open = nav.classList.toggle('open');
    toggle.classList.toggle('active', open);
    document.body.style.overflow = open ? 'hidden' : '';
  });
  nav.querySelectorAll('a').forEach(a => {
    a.addEventListener('click', () => {
      nav.classList.remove('open');
      toggle.classList.remove('active');
      document.body.style.overflow = '';
    });
  });
}

// ─── STICKY HEADER SCROLL CLASS ───
function initStickyHeader() {
  const header = document.querySelector('.site-header');
  if (!header) return;
  window.addEventListener('scroll', () => {
    header.classList.toggle('scrolled', window.scrollY > 10);
  }, { passive: true });
}

// ─── FAQ ACCORDION ───
function initFAQ() {
  document.querySelectorAll('.faq-question').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.faq-item');
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item.open').forEach(i => i.classList.remove('open'));
      if (!isOpen) item.classList.add('open');
    });
  });
}

// ─── PRODUCT TABS ───
function initTabs() {
  document.querySelectorAll('.tab-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const target = btn.dataset.tab;
      const parent = btn.closest('.product-tabs');
      if (!parent) return;
      parent.querySelectorAll('.tab-btn').forEach(b => b.classList.remove('active'));
      parent.querySelectorAll('.tab-pane').forEach(p => p.classList.remove('active'));
      btn.classList.add('active');
      const pane = parent.querySelector('[data-tab-pane="' + target + '"]');
      if (pane) pane.classList.add('active');
    });
  });
}

// ─── PRODUCT GALLERY ───
function initGallery() {
  const thumbs = document.querySelectorAll('.gallery-thumb');
  const mainImg = document.querySelector('.gallery-main img');
  if (!thumbs.length || !mainImg) return;
  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      const src = thumb.dataset.src;
      if (!src) return;
      mainImg.src = src;
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
    });
  });
}

// ─── VARIANT SELECTION ───
function initVariants() {
  document.querySelectorAll('.variant-buttons').forEach(group => {
    group.querySelectorAll('.variant-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        if (btn.classList.contains('sold-out')) return;
        group.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        const label = group.closest('.product-variants');
        if (label) {
          const strong = label.querySelector('.variant-label strong');
          if (strong) strong.textContent = btn.textContent.trim();
        }
      });
    });
  });
}

// ─── QUANTITY INPUT ───
function initQty() {
  document.querySelectorAll('.qty-input-wrap').forEach(wrap => {
    const input = wrap.querySelector('input');
    const minus = wrap.querySelector('[data-qty="minus"]');
    const plus = wrap.querySelector('[data-qty="plus"]');
    if (!input) return;
    if (minus) minus.addEventListener('click', () => {
      const v = parseInt(input.value) || 1;
      if (v > 1) input.value = v - 1;
    });
    if (plus) plus.addEventListener('click', () => {
      const v = parseInt(input.value) || 1;
      input.value = v + 1;
    });
    input.addEventListener('change', () => {
      if (parseInt(input.value) < 1 || isNaN(parseInt(input.value))) input.value = 1;
    });
  });
}

// ─── TOAST ───
function showToast(msg, type = 'success') {
  let container = document.querySelector('.toast-container');
  if (!container) {
    container = document.createElement('div');
    container.className = 'toast-container';
    document.body.appendChild(container);
  }
  const toast = document.createElement('div');
  toast.className = 'toast' + (type === 'error' ? ' error' : '');
  toast.textContent = msg;
  container.appendChild(toast);
  setTimeout(() => {
    toast.style.opacity = '0';
    toast.style.transform = 'translateY(12px)';
    toast.style.transition = '0.3s';
    setTimeout(() => toast.remove(), 300);
  }, 3200);
}

// ─── CART DRAWER ───
function initCartDrawer() {
  const overlay = document.getElementById('cart-drawer-overlay');
  const drawer = document.getElementById('cart-drawer');
  const closeBtn = document.getElementById('drawer-close');
  const cartBtns = document.querySelectorAll('[data-open-cart]');
  if (!overlay || !drawer) return;
  const open = () => {
    overlay.classList.add('open');
    drawer.classList.add('open');
    document.body.style.overflow = 'hidden';
  };
  const close = () => {
    overlay.classList.remove('open');
    drawer.classList.remove('open');
    document.body.style.overflow = '';
  };
  cartBtns.forEach(btn => btn.addEventListener('click', (e) => { e.preventDefault(); open(); fetchCart(); }));
  if (closeBtn) closeBtn.addEventListener('click', close);
  overlay.addEventListener('click', close);
}

// ─── FETCH & RENDER CART ───
function fetchCart() {
  const body = document.getElementById('cart-drawer-body');
  const footer = document.getElementById('cart-drawer-footer');
  if (!body) return;
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => renderDrawerCart(cart, body, footer))
    .catch(() => {});
}

function renderDrawerCart(cart, body, footer) {
  if (!cart.item_count) {
    body.innerHTML = '<div class="cart-drawer-empty"><div class="icon">🛒</div><p>Your cart is empty.</p></div>';
    if (footer) footer.innerHTML = '<a href="/collections/all" class="btn btn-primary btn-full">Shop Now</a>';
    return;
  }
  body.innerHTML = cart.items.map(item => `
    <div class="cart-item" data-key="${item.key}">
      <div class="cart-item-image">
        ${item.image ? `<img src="${item.image}" alt="${item.title}">` : '<div style="width:100%;height:100%;display:flex;align-items:center;justify-content:center;font-size:1.5rem">📦</div>'}
      </div>
      <div class="cart-item-details">
        <h4>${item.product_title}</h4>
        ${item.variant_title ? `<div class="cart-item-variant">${item.variant_title}</div>` : ''}
        <div style="display:flex;align-items:center;gap:0.75rem;margin-top:0.5rem;">
          <div class="qty-input-wrap" style="transform:scale(0.85);transform-origin:left;">
            <button class="qty-btn" data-qty="minus" data-key="${item.key}">−</button>
            <input type="number" value="${item.quantity}" min="1" data-key="${item.key}" class="drawer-qty-input">
            <button class="qty-btn" data-qty="plus" data-key="${item.key}">+</button>
          </div>
        </div>
        <button class="cart-item-remove" data-key="${item.key}">Remove</button>
      </div>
      <div class="cart-item-price">${formatMoney(item.line_price)}</div>
    </div>
  `).join('');

  if (footer) {
    footer.innerHTML = `
      <div class="cart-drawer-total"><span>Subtotal</span><span>${formatMoney(cart.total_price)}</span></div>
      <a href="/checkout" class="btn btn-primary btn-full" style="margin-bottom:0.6rem;">Checkout</a>
      <a href="/cart" class="btn btn-ghost btn-full">View Cart</a>
    `;
  }
  updateCartCount(cart.item_count);

  body.querySelectorAll('.cart-item-remove').forEach(btn => {
    btn.addEventListener('click', () => {
      updateCartItem(btn.dataset.key, 0);
    });
  });
  body.querySelectorAll('.qty-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const key = btn.dataset.key;
      const input = body.querySelector(`.drawer-qty-input[data-key="${key}"]`);
      if (!input) return;
      let v = parseInt(input.value) || 1;
      if (btn.dataset.qty === 'minus') v = Math.max(0, v - 1);
      else v += 1;
      updateCartItem(key, v);
    });
  });
}

function updateCartItem(key, quantity) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity })
  })
  .then(r => r.json())
  .then(cart => {
    const body = document.getElementById('cart-drawer-body');
    const footer = document.getElementById('cart-drawer-footer');
    renderDrawerCart(cart, body, footer);
    updateCartCount(cart.item_count);
  })
  .catch(() => {});
}

function updateCartCount(count) {
  document.querySelectorAll('.cart-count').forEach(el => {
    el.textContent = count;
    el.style.display = count > 0 ? 'flex' : 'none';
  });
}

function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2);
}

// ─── ADD TO CART ───
function initAddToCart() {
  document.querySelectorAll('[data-atc-form]').forEach(form => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const btn = form.querySelector('[data-atc-btn]');
      const variantId = form.querySelector('[name="id"]')?.value;
      const qty = parseInt(form.querySelector('[name="quantity"]')?.value) || 1;
      const note = form.querySelector('[name="properties[Custom Note]"]')?.value;
      if (!variantId) { showToast('Please select a variant.', 'error'); return; }
      if (btn) { btn.disabled = true; btn.innerHTML = '<span class="spinner"></span> Adding...'; }
      const props = {};
      if (note) props['Custom Note'] = note;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty, properties: props })
      })
      .then(r => r.json())
      .then(item => {
        showToast('Added to cart!');
        fetchCart();
        const overlay = document.getElementById('cart-drawer-overlay');
        const drawer = document.getElementById('cart-drawer');
        if (overlay && drawer) {
          overlay.classList.add('open');
          drawer.classList.add('open');
          document.body.style.overflow = 'hidden';
        }
      })
      .catch(() => showToast('Something went wrong.', 'error'))
      .finally(() => {
        if (btn) { btn.disabled = false; btn.innerHTML = 'Add to Cart'; }
      });
    });
  });
}

// ─── COLLECTION FILTER PILLS ───
function initFilterPills() {
  document.querySelectorAll('.filter-pill').forEach(pill => {
    pill.addEventListener('click', () => {
      document.querySelectorAll('.filter-pill').forEach(p => p.classList.remove('active'));
      pill.classList.add('active');
      const filter = pill.dataset.filter;
      const grid = document.querySelector('.products-grid');
      if (!grid || filter === 'all') {
        grid?.querySelectorAll('.product-card').forEach(c => c.style.display = '');
        return;
      }
      grid.querySelectorAll('.product-card').forEach(card => {
        const tag = card.dataset.tag || '';
        card.style.display = tag.includes(filter) ? '' : 'none';
      });
    });
  });
}

// ─── CUSTOM ORDER SERVICE SELECTOR ───
function initServiceSelector() {
  document.querySelectorAll('.service-option').forEach(opt => {
    opt.addEventListener('click', () => {
      document.querySelectorAll('.service-option').forEach(o => o.classList.remove('active'));
      opt.classList.add('active');
      const hiddenInput = document.getElementById('selected-service');
      if (hiddenInput) hiddenInput.value = opt.dataset.service || '';
    });
  });
}

// ─── FILE UPLOAD DRAG & DROP ───
function initFileUpload() {
  document.querySelectorAll('.file-upload-area').forEach(area => {
    const input = area.querySelector('input[type="file"]');
    area.addEventListener('click', () => input?.click());
    area.addEventListener('dragover', (e) => { e.preventDefault(); area.classList.add('dragover'); });
    area.addEventListener('dragleave', () => area.classList.remove('dragover'));
    area.addEventListener('drop', (e) => {
      e.preventDefault();
      area.classList.remove('dragover');
      if (input && e.dataTransfer.files.length) {
        input.files = e.dataTransfer.files;
        area.querySelector('p').innerHTML = `<strong>${e.dataTransfer.files[0].name}</strong> selected`;
      }
    });
    input?.addEventListener('change', () => {
      if (input.files.length) {
        area.querySelector('p').innerHTML = `<strong>${input.files[0].name}</strong> selected`;
      }
    });
  });
}

// ─── CUSTOM QUOTE FORM SUBMIT ───
function initQuoteForm() {
  const form = document.getElementById('custom-quote-form');
  if (!form) return;
  form.addEventListener('submit', (e) => {
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    if (btn) { btn.disabled = true; btn.textContent = 'Sending...'; }
    const fd = new FormData(form);
    fetch(form.action, { method: 'POST', body: fd })
      .then(() => {
        form.innerHTML = `
          <div style="text-align:center;padding:3rem 0;">
            <div style="font-size:3rem;margin-bottom:1rem;">✅</div>
            <h3 style="color:var(--text);margin-bottom:0.5rem;">Request Received!</h3>
            <p>We'll review your details and get back to you within 1 business day.</p>
          </div>
        `;
      })
      .catch(() => {
        showToast('Submission failed. Please email us directly.', 'error');
        if (btn) { btn.disabled = false; btn.textContent = 'Submit Request'; }
      });
  });
}

// ─── NEWSLETTER FORM ───
function initNewsletter() {
  document.querySelectorAll('.newsletter-form').forEach(form => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const email = form.querySelector('input[type="email"]')?.value;
      if (!email) return;
      showToast('You\'re on the list! 🎉');
      form.reset();
    });
  });
}

// ─── SHIPPING BAR ───
function initShippingBar() {
  const bar = document.querySelector('.shipping-progress-bar');
  if (!bar) return;
  const threshold = 7500;
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      const total = cart.total_price;
      const pct = Math.min(100, (total / threshold) * 100);
      const fill = bar.querySelector('.progress-fill');
      if (fill) fill.style.width = pct + '%';
      const msg = bar.querySelector('.bar-message');
      if (msg) {
        if (pct >= 100) {
          msg.textContent = '🎉 You\'ve unlocked free shipping!';
        } else {
          const remaining = formatMoney(threshold - total);
          msg.textContent = `Add ${remaining} more for free shipping`;
        }
      }
    })
    .catch(() => {});
}

// ─── INIT ───
document.addEventListener('DOMContentLoaded', () => {
  initMobileNav();
  initStickyHeader();
  initFAQ();
  initTabs();
  initGallery();
  initVariants();
  initQty();
  initCartDrawer();
  initAddToCart();
  initFilterPills();
  initServiceSelector();
  initFileUpload();
  initQuoteForm();
  initNewsletter();
  initShippingBar();
  fetchCart().catch(() => {});
});
